import { apiRole } from '../apiRole'
import apiUrls from '../urls'

export default function (api) {
	return {
		sendPoints(data) {
			return api.post(apiRole.isDedicatedDistributor
				? apiUrls.DIST_USER_IDENTITIES
				: apiUrls.USER_IDENTITIES, data, {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
				},
			})
		},
	}
}
